module.exports = __webpack_public_path__ + "img/backslash.66b33381.png";